import { NavLink } from "react-router-dom";
import type { ReactNode } from "react";
import { useAuth } from "../auth";
import { Icon, type IconName } from "./Icon";

type NavItem = { to: string; label: string; icon: IconName; end?: boolean };

const READINGS: NavItem[] = [
  { to: "/", label: "Overview", icon: "house", end: true },
  { to: "/readings", label: "Calendar", icon: "calendar" },
  { to: "/scrape", label: "Scrape", icon: "download" },
];

const PUBLISH: NavItem[] = [
  { to: "/publish", label: "Review & publish", icon: "cloud" },
  { to: "/sync", label: "Firestore sync", icon: "sync" },
];

const REFERENCE: NavItem[] = [
  { to: "/languages", label: "Languages", icon: "globe" },
  { to: "/schema", label: "Schema", icon: "doc" },
];

const SETTINGS: NavItem[] = [{ to: "/settings", label: "Settings", icon: "gear" }];

function navClass({ isActive }: { isActive: boolean }) {
  return isActive ? "nav-link active" : "nav-link";
}

function NavItems({ items }: { items: NavItem[] }) {
  return (
    <>
      {items.map((item) => (
        <NavLink key={item.to} to={item.to} end={item.end} className={navClass}>
          <Icon name={item.icon} size={16} />
          <span>{item.label}</span>
        </NavLink>
      ))}
    </>
  );
}

export function AppShell({ children }: { children: ReactNode }) {
  const { user, signOut } = useAuth();

  const identity = user?.email ?? user?.sub ?? "Signed in";
  const initial = (user?.email ?? "G").trim().charAt(0).toUpperCase();

  return (
    <div className="app-shell">
      <aside className="sidebar" aria-label="Primary">
        <div className="sidebar-brand">
          <div className="logo" aria-hidden="true">
            G
          </div>
          <div>
            <strong>GospelGo</strong>
            <span>Admin</span>
          </div>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section">Readings</div>
          <NavItems items={READINGS} />
          <div className="nav-section">Workflow</div>
          <NavItems items={PUBLISH} />
          <div className="nav-section">Reference</div>
          <NavItems items={REFERENCE} />
          <div className="nav-section">Account</div>
          <NavItems items={SETTINGS} />
        </nav>

        <div className="sidebar-foot">
          <div className="account">
            <div className="avatar" aria-hidden="true">
              {initial}
            </div>
            <div className="account-meta">
              <strong title={identity}>{identity}</strong>
              <span>Administrator</span>
            </div>
          </div>
          <button
            className="btn btn-quiet btn-block btn-sm"
            type="button"
            onClick={() => void signOut()}
          >
            <Icon name="signout" size={14} />
            Sign out
          </button>
        </div>
      </aside>

      <main className="content">
        <div className="content-inner">{children}</div>
      </main>
    </div>
  );
}
